// Recovered compiled webpack factory 65181. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { W: () => n });
  function n(t) {
    return "function" == typeof t && "applyToOptions" in t;
  }
}
